module.exports = __webpack_public_path__ + "static/media/elevator-music.26e30108.mp3";